import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { decodeAccessToken, getDomain } from "../helpers/helpers";

export default function AuthorizePage() {
    const location = useLocation();
    const navigate = useNavigate();


    useEffect(() => {
        const handleAuth = async () => {
            const searchParams = new URLSearchParams(location.search);
            const domainObject = getDomain();

            const code = searchParams.get("code");
            const token = searchParams.get("token");
            const state = searchParams.get("state") || 'someState';
            const response_type = searchParams.get("response_type") || 'code';
            const client_id = searchParams.get("client_id") || process.env.REACT_APP_CLIENT_ID;
            const redirect_uri = searchParams.get("redirect_uri") || `${domainObject.domain}/authorize`;
            const grant_type = searchParams.get("grant_type") || 'authorization_code';
            const google_token = searchParams.get("google_token");

            // 1) OAuth callback: validate expected "happy path" cases
            const isValid =
                // Happy path 1: only code
                (code && !token) ||
                // Happy path 2: token with everything
                (!code && token && !google_token && state && response_type && client_id && redirect_uri && grant_type) ||
                // Happy path 3: only google_token
                (google_token && !code && !token && !state && !response_type && !client_id && !redirect_uri && !grant_type);

            if (!isValid) {
                window.location.href = `${window.location.origin}/login`;
                return;
            }

            try {
                // Prepare data
                const formData = new FormData();
                formData.append("code", code || "");
                formData.append("token", token || "");
                formData.append("google_token", google_token || "");
                formData.append("redirect_uri", redirect_uri || "");
                formData.append("grant_type", grant_type || "");
                formData.append("state", state || "");
                formData.append("response_type", response_type || "");
                formData.append("client_id", client_id || "");
                formData.append("client_secret", process.env.REACT_APP_CLIENT_SECRET || "");
                formData.append("code_verifier", "confidential");
                formData.append("user_agent_type", "ADMIN")
  
                // 👇 Replace this with your API function
                const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}oauth/token`, {
                    method: "POST",
                    body: formData,
                }).then((res) => res.json());

                if (response) {
                    try {
                        localStorage.setItem("token", response.access_token);
                        localStorage.setItem("refresh_token", response.refresh_token);
                        const decodetoken = decodeAccessToken()
                        localStorage.setItem("unique_session_id", decodetoken.unique_session_id);
                        localStorage.setItem("admin_email", decodetoken.email);
                        window.location.href = "/"
                    } catch (e) {
                        console.error("Storage blocked", e);
                        window.location.href = "/login"
                    }

                    
                }

            } catch (err) {
                console.error("Auth error:", err);
                toast.error("Authentication failed. Please try again.");
            }
        };

        handleAuth();
    }, [location, navigate]);

    return (
        <div className="flex flex-col items-center justify-start min-h-screen bg-white pt-[30vh]">
            {/* Loader */}
            <div className="flex space-x-3 mb-6">
                <span
                    className="w-3 h-3 bg-[hsl(var(--primary))] rounded-full animate-bounce"
                    style={{ animationDelay: "0ms" }}
                ></span>
                <span
                    className="w-3 h-3 bg-[hsl(var(--primary))] rounded-full animate-bounce"
                    style={{ animationDelay: "150ms" }}
                ></span>
                <span
                    className="w-3 h-3 bg-[hsl(var(--primary))] rounded-full animate-bounce"
                    style={{ animationDelay: "300ms" }}
                ></span>
            </div>

            {/* Text */}
            <h2 className="text-lg font-semibold text-gray-900 mb-1">
                Authenticating
            </h2>
            <p className="text-gray-500 text-center max-w-xs">
                We&apos;re verifying your credentials.<br />
                Please hold on for a moment.
            </p>
        </div>

    );
}
